const steeringRecoDrawerColumns = [
  { id: 'action reco', label: 'ACTION RECO', sticky: true, right: 833, width: 170 },
  { id: 'agreeDisagreeStatus', label: 'AGREE ACTION RECO', sticky: true, right: 661, width: 172 },
  {
    id: 'recommendation',
    label: 'RECOMMENDATION (MAX 24 CHAR)*',
    sticky: true,
    right: 386,
    width: 200
  },
  { id: 'comment', label: 'COMMENTS*', sticky: true, right: 202, width: 152 },
  { id: 'taggedUsers', label: 'REQUEST INPUT FROM', sticky: true, right: 0, width: 170 }
];

const functionalFeedbackDrawerColumns = [
  {
    id: 'steering team recommendation',
    label: 'STEERING TEAM RECOMMENDATION',
    sticky: true,
    right: 556,
    width: 172
  },
  {
    id: 'agreeDisagreeStatus',
    label: 'AGREE STEERING TEAM RECO',
    sticky: true,
    right: 384,
    width: 172
  },
  { id: 'comment', label: 'COMMENTS*', sticky: true, right: 202, width: 150 },
  { id: 'taggedUsers', label: 'REQUEST INPUT FROM', sticky: true, right: 0, width: 170 }
];

const regionalDecisionDrawerColumns = [
  {
    id: 'steering team recommendation',
    label: 'STEERING TEAM RECOMMENDATION',
    sticky: true,
    right: 680,
    width: 172
  },
  {
    id: 'agreeDisagreeStatus',
    label: 'AGREE STEERING TEAM RECO',
    sticky: true,
    right: 508,
    width: 172
  },
  {
    id: 'recommendation',
    label: 'RECOMMENDATION (MAX 24 CHAR)*',
    sticky: true,
    right: 232,
    width: 200
  },
  { id: 'comment', label: 'COMMENTS*', sticky: true, right: 0, width: 200 }
];

export function restructureData(data) {
  return data.map((item) => {
    // Extract the "sku name" and "tposku" keys along with the rest of the object
    const { 'sku name': skuName, tposku, ...rest } = item;
    // Return a new object with "sku name" and "tposku" as the first two keys
    return { 'sku name': skuName, tposku, ...rest };
  });
}

export const getColumns = (content, level, drawervisible, showVotingViewScreen, selectedRegion) => {
  const columns = [];
  const keysObj = content?.[0] || {};
  const drawerColumns =
    level === 'Steering Reco'
      ? steeringRecoDrawerColumns
      : level === 'Functional Feedback'
        ? functionalFeedbackDrawerColumns
        : regionalDecisionDrawerColumns;

  if (content) {
    // Process other columns first
    Object.keys(keysObj)
      ?.filter((list) => list !== 'CycleSKUKey' && list !== 'IsVotingDone')
      ?.map((item, index) => {
        if (item === 'regionChannelRecord') {
          return [];
        } else if(item === 'regional team votes') {
          const regionalRecoCols = keysObj[item]
            .map((record) => {
              const key = Object.keys(record)[0];
              if (selectedRegion && !key.startsWith(selectedRegion)) {
                return null;
              }
              return {
                label: key.toUpperCase(),
                id: key
              };
            })
            .filter(Boolean);

          regionalRecoCols?.forEach((col) => {
            if (!columns.some((c) => c.id === col.id)) {
              columns.push(col);
            }
          });
        }else {
          if (item !== 'votingVotesEntities') {
            // Skip adding votingVotesEntities here
            if (index === 0) {
              columns.push({
                label: item.toUpperCase(),
                id: item,
                sticky: true,
                left: showVotingViewScreen ? 0 : 52,
                showBorder: true,
                width: 170
              });
            } else {
              columns.push({ label: item.toUpperCase(), id: item });
            }
          }
        }
        return item;
      });

    // Add the votingVotesEntities columns at the end, if visible
    if (drawervisible) {
      columns.push(...drawerColumns); // Always add drawerColumns here
    }
  }
  return columns.filter((column) => column.id!=='delist rank')
};

/**
 * The function `getData` sorts voting entities by ModifiedOn date in descending order and updates each
 * item with the most recent entry if it matches the CycleSKUKey.
 * @param content - The `getData` function takes in an array of `content` objects. It maps over each
 * object in the array and performs the following operations:
 * @returns The `getData` function returns an array of objects with updated properties based on the
 * most recent entry in the `votingVotesEntities` array for each item in the input `content` array. The
 * properties `agreeDisagreeStatus`, `recommendation`, `comment`, and `taggedUsers` are updated in each
 * object if the `CycleSKUKey` matches the most recent entry's `Cycle
 */


export const getData = (content, tableName = '',taskName = '') => {
  console.log("content in getData",content)
  const customData = content?.map((item) => {
    let temp = Object.assign({}, item);
    // const idx = Object.assign({},item)
    // Sort votingVotesEntities by ModifiedOn in descending order (most recent first)
    const sortedVotingEntities = item.votingVotesEntities?.sort((a, b) => {
      return new Date(b.ModifiedOn) - new Date(a.ModifiedOn);
    });

    // Take the first (most recent) entry if exists
    const mostRecentEntry = sortedVotingEntities?.[0];

    let upCount = 0;
    let downCount = 0;
    item?.['regional team votes']?.forEach((region) => {
      const regionData = Object.entries(region)[0]; // Get key-value pair of region
      const regionKey = regionData[0];
      const regionValue = regionData[1];
      if (regionValue === true) {
        upCount++; // Increment count for true
      } else if (regionValue === false) {
        downCount++; // Increment count for false
      }
      temp[regionKey] = regionValue;
    });
    if (item.CycleSKUKey === mostRecentEntry?.CycleSKUKey) {
      temp = {
        ...temp,
        ...{
          agreeDisagreeStatus: mostRecentEntry?.AgreeDisagreeStatus,
          recommendation: mostRecentEntry?.Recommendation,
          comment: mostRecentEntry?.Comment,
          taggedUsers: mostRecentEntry?.TaggedUsers
        }
      };
    } else if (sortedVotingEntities !== null && sortedVotingEntities?.length === 0) {
      temp = {
        ...temp,
        ...{
          agreeDisagreeStatus: null,
          recommendation: null,
          comment: null,
          taggedUsers: null
        }
      };
    }
    if (tableName === 'Decision Table') {
      temp['REGIONAL TEAM VOTES'] = { upVote: upCount, downVote: downCount };
      temp['INPUTS FROM REGIONAL TEAMS'] = {};
      temp = {
        ...temp,
        ...{
          comment: item?.comment
        }
      };
    }
    if((tableName === "RecommendationTable"||tableName === 'Decision Table') && taskName !== "Steering Reco"){
        temp['steering team recommendation'] = item?.['steering team recommendation'] || item?.['action reco']
    }
    return temp;
  });
  return tableName === 'RecommendationTable'
    ? customData?.map((list) => {
        let filteredList = [...new Set(list['requested input from'])];
        list['requested input from'] =
          list['requested input from']?.length > 0 ? filteredList?.sort()?.join(',') : '';
        return list;
      })
    : customData;
};


export const steeringReco = [
  { key: 'segment', label: 'Segment', dependsOn: [] },
  { key: 'brand', label: 'Brand', dependsOn: ['segment'] },
  { key: 'sub-brand', label: 'Sub Brand', dependsOn: ['segment', 'brand'] },
  { key: 'packSize', label: 'Size', dependsOn: ['segment', 'brand', 'sub-brand'] },
  { key: 'sku name', label: 'SKU', dependsOn: ['segment', 'brand', 'sub-brand', 'packSize'] }
];

export const functionalFeedback = [
  { key: 'segment', label: 'Segment', dependsOn: [] },
  { key: 'brand', label: 'Brand', dependsOn: ['segment'] },
  { key: 'sub-brand', label: 'Sub Brand', dependsOn: ['segment', 'brand'] },
  { key: 'packSize', label: 'Size', dependsOn: ['segment', 'brand', 'sub-brand'] },
  { key: 'sku name', label: 'SKU', dependsOn: ['segment', 'brand', 'sub-brand', 'packSize'] },
  {
    key: 'requested input from',
    label: 'Assigned to',
    dependsOn: ['segment', 'brand', 'sub-brand', 'packSize', 'sku name']
  },
  {
    key: 'level_attribute_name',
    label: 'Customer',
    dependsOn: []
  }
];

export const regionalDecisions = [
  { key: 'segment', label: 'Segment', dependsOn: [] },
  { key: 'brand', label: 'Brand', dependsOn: ['segment'] },
  { key: 'sub-brand', label: 'Sub Brand', dependsOn: ['segment', 'brand'] },
  { key: 'packSize', label: 'Size', dependsOn: ['segment', 'brand', 'sub-brand'] },
  { key: 'sku name', label: 'SKU', dependsOn: ['segment', 'brand', 'sub-brand', 'packSize'] },
  {
    key: 'requested input from',
    label: 'Assigned to',
    dependsOn: ['segment', 'brand', 'sub-brand', 'packSize', 'sku name']
  }
];

export const finalDecisions = [
  { key: 'segment', label: 'Segment', dependsOn: [] },
  { key: 'brand', label: 'Brand', dependsOn: ['segment'] },
  { key: 'sub-brand', label: 'Sub Brand', dependsOn: ['segment', 'brand'] },
  { key: 'packSize', label: 'Size', dependsOn: ['segment', 'brand', 'sub-brand'] },
  { key: 'sku name', label: 'SKU', dependsOn: ['segment', 'brand', 'sub-brand', 'packSize'] }
];

export const decisionCentral = [
  { key: 'segment', label: 'Segment', dependsOn: [] },
  { key: 'brand', label: 'Brand', dependsOn: ['segment'] },
  { key: 'sub-brand', label: 'Sub Brand', dependsOn: ['segment', 'brand'] },
  { key: 'sku name', label: 'SKU', dependsOn: ['segment', 'brand', 'sub-brand'] },
  {
    key: 'votes aligned',
    label: 'Votes Aligned',
    dependsOn: ['segment', 'brand', 'sub-brand', 'sku name']
  }
];

export const parseVotingTableData = (data = []) => {
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data.map((item) => {
      return {
        segment: item.segment || '',
        brand: item.brand || '',
        'sub-brand': item['sub-brand'] || '',
        packSize: item['packSize'] || '',
        'sku name': item['sku name'] || '',
        'votes aligned':
          item['votes aligned'] === true
            ? 'Yes'
            : item['votes aligned'] === false
              ? 'No'
              : item['votes aligned'] === null
                ? ''
                : item['votes aligned'],
        'requested input from':
          Array.isArray(item['requested input from']) && item['requested input from'].length > 0
            ? item['requested input from']
                .flat()
                .filter((user) => user && typeof user === 'string' && user.trim())
            : []
      };
    });
  }
};

export const filterByLevel = (arr, levelFilter) => {
  return arr?.filter((obj) => {
    // If the object has a 'level' property, check if it matches levelFilter
    if ('level' in obj) {
      return obj.level === levelFilter;
    }
    // Otherwise, include the object
    return true;
  });
};

export const generateKPIHighlightText = (kpiHighlighter) => {
  return Object.keys(kpiHighlighter).map((key) => (
    <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      Columns highlighted with
      <span
        style={{
          display: 'inline-block',
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: kpiHighlighter[key].color
        }}
      />
      <span> color represents {key === 'level_attribute_name' ? 'customer' : key} level data.</span>
    </div>
  ));
};
